import { uploadLinksArchive } from "../utils/api/uploadApi";

export const createEmptyBlock = (reactId) => ({
  reactId,
  campaign: "",
  client: "",
  format: "",
  width: "",
  height: "",
  device: "desktop",
  file: null,
});

export const INITIAL_LINK_BLOCKS = [createEmptyBlock(0)];

const applyDevicePreset = (block, field, value) => {
  const updatedBlock = {
    ...block,
    [field]: value,
  };

  if (field === "device" && value === "st_desktop") {
    return {
      ...updatedBlock,
      width: 1920,
      height: 1080,
      format: "INTERSTITIAL.sticky (desktop)",
    };
  }

  if (field === "device" && value === "st_mobile") {
    return {
      ...updatedBlock,
      width: 1080,
      height: 1920,
      format: "INTERSTITIAL.sticky (mobile)",
    };
  }

  return updatedBlock;
};

export const updateBlockField = (blocks, index, field, value) =>
  blocks.map((block, currentIndex) => {
    if (currentIndex !== index) return block;
    return applyDevicePreset(block, field, value);
  });

export const updateBlockFile = (blocks, index, file) =>
  blocks.map((block, currentIndex) =>
    currentIndex === index ? { ...block, file } : block
  );

export const removeBlockById = (blocks, reactId) =>
  blocks.filter((block) => block.reactId !== reactId);

const getNextBlockId = (blocks) =>
  blocks.reduce((maxId, block) => Math.max(maxId, block.reactId), -1) + 1;

export const addNewBlock = (blocks) => [...blocks, createEmptyBlock(getNextBlockId(blocks))];

export const duplicateBlockData = (blocks, reactId) => {
  const blockToDuplicate = blocks.find((block) => block.reactId === reactId);
  if (!blockToDuplicate) return blocks;

  const duplicatedBlock = {
    ...createEmptyBlock(getNextBlockId(blocks)),
    campaign: blockToDuplicate.campaign,
    client: blockToDuplicate.client,
    format: blockToDuplicate.format,
    width: blockToDuplicate.width,
    height: blockToDuplicate.height,
    device: blockToDuplicate.device,
    file: null,
  };

  return [...blocks, duplicatedBlock];
};

export const validateBlocks = (blocks) => {
  for (let i = 0; i < blocks.length; i += 1) {
    if (!blocks[i].file) return `Dodaj plik ZIP dla bloku nr ${i + 1}`;
    if (!blocks[i].campaign) return "Dodaj nazwe kampanii";
    if (!blocks[i].client) return "Dodaj klienta";
    if (!blocks[i].format) return "Dodaj format";
    if (!blocks[i].width) return "Dodaj szerokosc";
    if (!blocks[i].height) return "Dodaj wysokosc";
  }

  return "";
};

export const buildLinksUploadPayload = (blocks) => {
  const dataToSend = blocks.map(
    ({ campaign, client, format, width, height, device }) => ({
      campaign,
      client,
      format,
      width: parseInt(width, 10),
      height: parseInt(height, 10),
      device,
    })
  );

  const formData = new FormData();
  formData.append("data", JSON.stringify(dataToSend));
  blocks.forEach(({ file }) => {
    formData.append("zips", file);
  });

  return formData;
};

export const submitLinks = async ({ blocks, setLoading, setResults, setBlocks }) => {
  const validationMessage = validateBlocks(blocks);
  if (validationMessage) {
    alert(validationMessage);
    return false;
  }

  const formData = buildLinksUploadPayload(blocks);
  setLoading(true);

  try {
    const response = await uploadLinksArchive(formData);
    setResults(response?.data || []);
    setBlocks([]);
    return true;
  } catch (error) {
    alert("Cos poszlo nie tak podczas wysylania.");
    console.error(error);
    return false;
  } finally {
    setLoading(false);
  }
};
